import LocalStorage from "../partners/storage";
import CaratFilter from "../filters/carat_filter";
import ClarityFilter from "../filters/clarity_filter";
import ColorFilter from "../filters/color_filter";
import SettingDropdownFilter from "../filters/setting_filter";
import ShapeDropdownFilter from "../filters/shape_filter";
import BrandDropdownFilter from "../filters/brand_filter";
import WatchesBrandDropdownFilter from "../filters/watches_brand_filter";
import GenderFilter from "../filters/gender_filter";

export const RDStorage = new LocalStorage('recent_deals');

export const LOCAL_STORAGE_PREFIX = "recent_deals_filters_";

const FILTERS_IN_COMMON = [CaratFilter, ClarityFilter, ColorFilter, ShapeDropdownFilter];

export const FILTERS_PER_TYPE = {
    rings: [ SettingDropdownFilter, ...FILTERS_IN_COMMON, BrandDropdownFilter ],
    bracelets: [ ...FILTERS_IN_COMMON, BrandDropdownFilter ],
    earrings: [ ...FILTERS_IN_COMMON, BrandDropdownFilter ],
    necklaces: [ ...FILTERS_IN_COMMON, BrandDropdownFilter ],
    watches: [ WatchesBrandDropdownFilter, GenderFilter ],
    "loose-diamonds": [ ...FILTERS_IN_COMMON ],
//TODO: uncomment when we have a table for gemstone properties.    "loose-gemstones":[CaratFilter, ClarityFilter, ColorFilter, ShapeDropdownFilter]
};
